// QR widget. Legacy: addQRCode/generateQRImage/updateQRValue (snapshot L4302-4382).
// The legacy code used qrcodejs (a global with a setTimeout-to-read-the-DOM hack);
// the v2 port uses the npm `qrcode` lib whose toDataURL() is a clean Promise.
// Fabric v7 (map §4.2): await FabricImage.fromURL(dataUrl).
import { FabricImage, type FabricObject } from 'fabric'
import QRCode from 'qrcode'
import { getCanvas } from './../state'
import { labelPx } from './../canvas'
import { PRODUCT } from './../product'

const PLACEHOLDER = PRODUCT.qrPlaceholder

const isPlaceholder = (v: string | undefined): boolean =>
  !v || v.trim() === '' || /^\{\{[^}]+\}\}$/.test(v)

export function generateQRDataUrl(value: string): Promise<string> {
  return QRCode.toDataURL(value, {
    width: 256,
    margin: 1,
    color: { dark: '#0f172a', light: '#ffffff' },
    errorCorrectionLevel: 'M',
  })
}

export async function addQRCode(value = PLACEHOLDER): Promise<FabricImage> {
  const dataUrl = await generateQRDataUrl(value)
  const img = await FabricImage.fromURL(dataUrl)
  const { w, h } = labelPx()
  const size = Math.min(w, h) * 0.5
  const scale = size / img.width
  img.set({
    left: w / 2 - size / 2,
    top: h / 2 - size / 2,
    scaleX: scale,
    scaleY: scale,
    id: 'qr-' + Date.now(),
    qrValue: value,
  } as any)
  const c = getCanvas()
  c.add(img)
  c.setActiveObject(img)
  c.requestRenderAll()
  return img
}

/** Regenerate a QR object in place, preserving transform. */
export async function updateQRValue(obj: FabricObject, value: string): Promise<FabricImage | undefined> {
  if ((obj as any).qrValue == null) return
  const pos = { left: obj.left, top: obj.top, scaleX: obj.scaleX, scaleY: obj.scaleY, angle: obj.angle, id: (obj as any).id }
  const display = isPlaceholder(value) ? PLACEHOLDER : value
  const dataUrl = await generateQRDataUrl(display)
  const img = await FabricImage.fromURL(dataUrl)
  img.set({ ...pos, qrValue: value, opacity: isPlaceholder(value) ? 0.5 : 1 } as any)
  const c = getCanvas()
  c.remove(obj)
  c.add(img)
  c.setActiveObject(img)
  c.requestRenderAll()
  return img
}
